import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, ShieldCheck } from 'lucide-react';
const HeaderGlp6TipsE = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17331" data-mp="21l53t4g2z2vx">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17332" data-mp="2bchsjn6l1cxq"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17333" data-mp="2bely09k4qk04">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17334" data-mp="1eobg4e3f5g8w">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17335" data-mp="1ip55lbwif33w">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17336" data-mp="1np9p7aspsdyc">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17337" data-mp="2z1txubysh0ur">
          <div className="text-left" data-id="element-17338" data-mp="3439iw40yv7d5">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17339" data-mp="32b9757to3aoj">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17340" data-mp="2jezos8bqfxyq">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17341" data-mp="2aklc8dil71jb">
        <div className="max-w-4xl mx-auto" data-id="element-17342" data-mp="25ma201odqp0k">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17343" data-mp="25nl3tvy9lmp1">
            PERSONAL REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-2" data-id="element-17344" data-mp="1vodo52425fyr">
            What I Wish I Knew Before Starting Semaglutide
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-17345" data-mp="1m2un7eq5dk9t">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-17346" data-mp="1r0w35qsa13h2">
              <img src="https://cdn.magicpatterns.com/uploads/qo1VVrn8u2FTESbwCETPV1/1.jpg" alt="Dr. Tom Parham" className="w-full h-full object-cover" data-id="element-17347" data-mp="1d268siwudhwe" />
            </div>
            <div className="flex-1" data-id="element-17348" data-mp="24rj6jw8zfhjh">
              <div className="flex items-center" data-id="element-17349" data-mp="29q2s3vjnyrbb">
                <div className="font-medium text-gray-900 text-lg" data-id="element-17350" data-mp="29orel40f2570">
                  By Patricia Morrison, RN, CN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-17351" data-mp="1vwv042ro7tt3">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-17352" data-mp="1zyq1t8dik97e" />
                  <span className="text-xs ml-1 font-medium" data-id="element-17353" data-mp="2npbxs1a8u311">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17354" data-mp="2shluq19s03ct">
                Chicago, IL • Former Medical Practitioner • 58 Years Old • 4
                Years on GLP-1 Medications
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-17355" data-mp="c1gto7hweqwo">
                <div className="flex items-center mr-4" data-id="element-17356" data-mp="qr4u76i99ljc">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-17357" data-mp="qqmq5npcq30v" />
                  <span data-id="element-17358" data-mp="ls1p5m29zfbd">18 min read</span>
                </div>
                <div className="flex items-center" data-id="element-17359" data-mp="lunxhnwzpyun">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-17360" data-mp="3u96ck9lcmenr" />
                  <span data-id="element-17361" data-mp="3p91s68hbkzs9">42,372 views</span>
                </div>
              </div>
              <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-17362" data-mp="3pb4tvpru4hct">
                <ShieldCheck className="h-3.5 w-3.5 text-blue-600 mr-1 flex-shrink-0" data-id="element-17363" data-mp="82hrgunjx88x" />
                Medically Reviewed by{' '}
                <span className="text-blue-600 underline ml-1" data-id="element-17364" data-mp="346fad9salnj">
                  Robert Hill, MD, FACP
                </span>
              </div>
            </div>
          </div>

          <div className="my-4" data-id="element-17365" data-mp="1egpcroahygs3">
            <img src="https://cdn.magicpatterns.com/uploads/nwn6hondxNojcsAjvGQfEj/2.png" alt="Before and after transformation" className="w-full rounded-lg shadow-lg mb-3" data-id="element-17366" data-mp="3k5j1fjjzet5s" />
            <div className="flex justify-between items-center px-2 py-1 bg-gray-50 rounded border-t border-gray-200" data-id="element-17367" data-mp="3p6gly2sgrzag">
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-17368" data-mp="1zmrx4ij43qe">
                September 25, 2021
              </span>
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-17369" data-mp="6xy5nqby2ydw">
                December 7, 2025
              </span>
            </div>
          </div>

          <div className="my-4 border-l-4 border-gray-800 pl-6 py-4 bg-gradient-to-r from-gray-100 to-white shadow-sm" data-id="element-17370" data-mp="goanvbwaefgv">
            <p className="text-sm uppercase tracking-wide text-gray-500 mb-2 font-semibold" data-id="element-17371" data-mp="koumkjwidr54">
              ARTICLE SUMMARY
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic" data-id="element-17372" data-mp="pnea2oqr3azl">
              "What a Chicago nurse discovered after three years of crushing
              depression on semaglutide:
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-17373" data-mp="ztfjb4et64zo">
              6 science-backed strategies that address nausea, hair loss,
              fatigue, and the devastating 'flat feeling' without stopping your
              medication....
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-17374" data-mp="1nigu2yb45s84">
              — now helping 120+ GLP-1 users monthly at her weight loss clinic."
            </p>
          </div>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17375" data-mp="1dsoyq1v6wv2l">
            <div className="mb-1 flex items-center" data-id="element-17376" data-mp="19rv5qu2w4q2u">
              <span className="font-medium mr-2" data-id="element-17377" data-mp="19p9398uux0rh">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17378" data-mp="21irizvsv4wqn">
              <span className="font-medium mr-2" data-id="element-17379" data-mp="21h83w8iy0rqg">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlp6TipsE;